import { MonthlyExceptionsReports } from './../model/monthly-exceptions-reports';
import { AppSettingService } from './app-setting.service';
import { ExtensiveLoggingDto } from './../model/extensive-logging-dto';
import { PoTypesDto } from './../model/po-types-dto';
import { PoTypeDto } from './../model/po-type-dto';
import { ExceptionReportCCDto } from './../model/exception-report-cc-dto';
import { CustomerLocationIds } from './../model/customer-location-ids';
import { PurchaseOrderReportDto } from './../model/purchase-order-report-dto';
import { MonthlyExceptionReportM2m } from './../model/monthly-exception-report-m2m';
import { UnprocessedPoReportDto } from './../model/unprocessed-po-report-dto';
import { PBJReportDto } from './../model/pbjreport-dto';
import { MonthlyLocationDto } from '../model/monthly-location-dto';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Parentuseraccessdto } from '../model/parentuseraccessdto';
import { Parentfullfillmentdto } from '../model/parentfullfillmentdto';
import { Menubardto } from '../model/menubardto';
import { Enablesaveuseraccessdto } from '../model/enablesaveuseraccessdto';
import { Purchaseorderdto } from '../model/purchageorderdto';
import { Useradmindto } from '../model/useradmindto';
import { Usertypeandaccessdto } from '../model/usertypeandaccessdto';
import { OrderDetailsdto } from '../model/orderDetailsdto';
import { ExceptionReportDto } from '../model/exception-report-dto';
import { FulfillmentReportDto } from '../model/fulfillment-report-dto';
import { PartnerDto } from '../model/partner-dto';
import { EdiEdpar } from '../model/ediEdpar';
import { EdiMatlConv } from '../model/ediMatlConv';
import { EdiDunsMaster } from '../model/ediDunsMaster';
import { OrderInterfaceLogFileDto } from '../model/order-interface-log-file-dto';
import { ResultDto } from '../model/result-dto';
import { StoreConvert } from '../model/StoreConvert';
import { UpdateOrderDto } from '../model/update-order-dto';
import { BolItemLinesResponseDto } from '../model/bol-item-lines-response-dto';
import { OrderItemMasterDto } from '../model/order-item-master-dto';
import { BolResponse } from '../model/bol-response';
import { ServiceStatusDto } from '../model/service-status-dto';
import { PartnerOnboardingDto } from '../model/partner-onboarding-dto';
import { EnvConfigService } from './env-config.service';
import { PartnerOnboardingMasterDto } from '../model/partner-onboarding-master-dto';
import { PartnerOnboardingTransactionDto } from '../model/partner-onboarding-transaction-dto';
import { PartneStagingDto } from '../model/partne-staging-dto';
import { PoandPBJreportDto } from '../model/poand-pbjreport-dto';
import { MsoLocationReport } from './../model/mso-location-report';
import { BOLReportDTO } from '../model/bol-report-dto';
import { POLineItemDetailReportDTO } from '../model/po-line-item-detail-report-dto';
import { OrderItemDto } from '../model/OrderItemDto';
@Injectable({
  providedIn: 'root'
})
export class HttpclientService {

  public username: string;
  password: string;
  apiUrl: string;
  apiPoUrl: string;
  apiEdiMasterUrl: string;
  apiMasterUrl: string;
  apiPartnerOnboardingUrl: string;
  apiBolUrl: string;
  apiServiceStatusUrl: string;
  apiPurchaseOrderUrl: string;
  apiM2MURLHost: string;
  apiM2MURLProtocol: string;
  userLocation: string[];

  constructor(private httpClient: HttpClient, public appSettingService: AppSettingService,
    // tslint:disable-next-line:no-shadowed-variable
    //  public envConfigService: EnvConfigService
  ) {
    //  this.envConfigService= this.envConfigService.loadAppConfig();

    this.apiM2MURLProtocol = location.protocol;
    this.apiM2MURLHost = location.host;

    if (this.apiM2MURLHost.includes('localhost')) {
      this.apiM2MURLHost = 'localhost:8090';
    }

    this.apiUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/dashboard';
    this.apiPoUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/po';
    this.apiEdiMasterUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/edimaster';
    this.apiMasterUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/master';
    this.apiPartnerOnboardingUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/partnerOnboarding';
    this.apiBolUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/bol';
    this.apiServiceStatusUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/servicesCheck';
    this.apiPurchaseOrderUrl = this.apiM2MURLProtocol + '//' + this.apiM2MURLHost + '/purchaseOrder';
  }



  logOut1() {
    console.log(this.apiUrl + '/logout');
    return this.httpClient.get<boolean>(this.apiUrl + '/logout');

  }
  getMenubar() {
    return this.httpClient.get<Menubardto[]>(this.apiUrl + '/getMenubar?username=' + this.username);
  }
  getUserDetails(username: string, password: string) {
    this.username = username;
    this.password = password;
  }
  useraccesspage() {

    return this.httpClient.get<Parentuseraccessdto[]>(this.apiUrl + '/getUserAccess');
  }

  fulfillmentreport() {
    return this.httpClient.get<Parentfullfillmentdto[]>(this.apiUrl + '/getWeekOneFullfilmentReport');
  }
  getPurchaseOrder(username) {        
    return this.httpClient.get<Purchaseorderdto[]>(this.apiUrl + '/getPurchageOrder?username=' + username + '&userLocation=' + sessionStorage.getItem('userLocation'));                                                                
  }
  getuseradmin() {
    return this.httpClient.get<Useradmindto[]>(this.apiUrl + '/getuseradmin');

  }
  getusertypeNaccess() {
    return this.httpClient.get<Usertypeandaccessdto>(this.apiUrl + '/getusertypeNaccess');
  }
  saveuseraccess(useraccesscheckorunckeck) {
    return this.httpClient.post<Enablesaveuseraccessdto>(this.apiUrl
      + '/saveuseraccess', useraccesscheckorunckeck);
  }

  searchpobolinvoiceno(userName, search) {
    return this.httpClient.get<Purchaseorderdto[]>(this.apiUrl
      + '/searchpobolinvoiceno?userName=' + userName + '&search=' + search + '&userLocation=' + sessionStorage.getItem('userLocation'));
  }


  getOrderDetails(poNo,axaltacartkey,purchaseOrderNo) {
    return this.httpClient.get<OrderDetailsdto>(this.apiPurchaseOrderUrl + '/getOrderDetails/?axaltacartkey=' + axaltacartkey + '&purchaseOrderNo=' + purchaseOrderNo + '&poNo=' + poNo);
  }

  gePurchasetOrderDetails(poNo) {
    return this.httpClient.get<OrderDetailsdto>(this.apiPurchaseOrderUrl + '/gePurchasetOrderDetails/' + poNo);
  }

  
  getPDFForInvoice(invoiceId) {
    // return this.httpClient.get<any>(`${this.baseUrl}/get/pdf/${fileName}`, { responseType: 'arraybuffer' as 'json' });
    return this.httpClient.get<string>(this.apiPurchaseOrderUrl + '/getPDFForInvoice/' + invoiceId,{ responseType: 'arraybuffer' as 'json' });
  }

  datereangeselectionforpo(startdate, enddate, username, search) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<Purchaseorderdto[]>(this.apiUrl + '/datereangeselectionforpo?startdate=' + startdate + '&enddate=' + enddate + '&username=' + username + '&search=' + search + '&userLocation=' + sessionStorage.getItem('userLocation'));
  }

  getupdateuser(updatinguser) {           
    return this.httpClient.put<Enablesaveuseraccessdto>(this.apiUrl + '/updateuser', updatinguser);
  }

  savecreateduser(savingcreateuser) {
    return this.httpClient.post<Enablesaveuseraccessdto>(this.apiUrl + '/saveusercreation', savingcreateuser);
  }

  getMonthlyLocationReportByDate(reportDateRangeDto) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<MonthlyLocationDto[]>(this.apiUrl + '/getMonthlyLocationsReport', reportDateRangeDto);
  }

  getMonthlyExceptionsReportM2M(reportDateRangeDto) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<MonthlyExceptionReportM2m[]>(this.apiUrl + '/getMonthlyExceptionsReportM2M', reportDateRangeDto);
  }
  getFullfillmentReport(re) {
    return this.httpClient.post<FulfillmentReportDto[]>(this.apiUrl + '/getFullfilmentReport1', re);
  }

  getPBandJReport(re) {
    return this.httpClient.post<PoandPBJreportDto>(this.apiUrl + '/getPBandJReport', re);
  }

  getPBandJpoReport(re) {
    return this.httpClient.post<PoandPBJreportDto>(this.apiUrl + '/getPBandJpoReport', re);
  }

  getUnProcessReport(re) {
    return this.httpClient.post<UnprocessedPoReportDto[]>(this.apiUrl + '/getUnprocessedPoReport', re);
  }
  getPartnerList() {
    return this.httpClient.get<PartnerDto[]>(this.apiMasterUrl + '/getPartnerList');
  }
  getCustomerMatlDropdownList() {
    return this.httpClient.get<PartnerDto[]>(this.apiMasterUrl + '/getCustomerMatlDropdownList');
  }

  getMonthlyExceptionsReportCC(reportDateRangeDto) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<ExceptionReportCCDto[]>(this.apiUrl + '/getMonthlyExceptionsReportCC', reportDateRangeDto);
  }
  getEdiEdparDetails(search) {
    // return this.httpClient.get<EdiEdpar[]>(this.apiEdiMasterUrl + '/getEdiEdparDetails?queryVal=' + search);
    const promise = this.httpClient.get<EdiEdpar[]>(this.apiEdiMasterUrl
      + '/getEdiEdparDetails?queryVal=' + search).toPromise();
    return promise;
  }
  getPartnerListMSO() {
    return this.httpClient.get<PartnerDto[]>(this.apiMasterUrl + '/getPartnerListMSO');
  }

  getEdiMatlConvDetails(search: string) {
    // return this.httpClient.get<EdiMatlConv[]>(this.apiEdiMasterUrl
    // + '/getEdiMatlConvDetails?queryVal=' + search);
    const promise = this.httpClient.get<EdiMatlConv[]>(this.apiEdiMasterUrl
      + '/getEdiMatlConvDetails?queryVal=' + search).toPromise();
    return promise;
  }
  getEdiDunsMasterDetails(search: string) {
    // return this.httpClient.get<EdiDunsMaster[]>(this.apiEdiMasterUrl
    //     + '/getEdiDunsMasterDetails?queryVal=' + search);
    const promise = this.httpClient.get<EdiDunsMaster[]>(this.apiEdiMasterUrl
      + '/getEdiDunsMasterDetails?queryVal=' + search).toPromise();
    return promise;
  }

  getOrderFileDownloadDebitCredit(docId, fileId, fileArchivalId) {
    return this.httpClient.get<OrderInterfaceLogFileDto>(this.apiPurchaseOrderUrl +
      '/getOrderFileDownloadDebitCredit/' + docId + '/' + fileId + '/' + fileArchivalId);
  }

  getOrderFileDownload(docId, fileId, uniqueIdentificationText) {
    return this.httpClient.get<OrderInterfaceLogFileDto>(this.apiPurchaseOrderUrl +
      '/getOrderFileDownload/' + docId + '/' + fileId + '/' + uniqueIdentificationText);
  }

  // savleOrderReprocess(poId, docId, fileId, fileName, uniqueIdentificationText, poType) {
  //   return this.httpClient.get<ResultDto>
  //   (this.envConfigService.appConfig.apiPoUrl + '/savleOrderReprocess/'
  //    + poId + '/' + docId + '/' + fileId + '/' + fileName + '/' + uniqueIdentificationText + '/' + poType );
  // }
  savleOrderReprocess(orderReprocessDto) {
    return this.httpClient.post<ResultDto>
      (this.apiPurchaseOrderUrl + '/savleOrderReprocess/',
        orderReprocessDto);
  }

  getStoreConvertDetails(search: string) {
    // return this.httpClient.get<StoreConvert[]>(this.apiEdiMasterUrl
    // + '/getStoreConvertDetails?queryVal=' + search);
    const promise = this.httpClient.get<StoreConvert[]>(this.apiEdiMasterUrl
      + '/getStoreConvertDetails?queryVal=' + search)
      .toPromise();
    return promise;
  }

  updateediedpar(updatingediedpar) {
    return this.httpClient.put<EdiEdpar>(this.apiEdiMasterUrl + '/updateEdiEdparDetails', updatingediedpar);
  }

  updateedidunsmaster(updatingedidunsmaster) {
    return this.httpClient.put<EdiDunsMaster>(this.apiEdiMasterUrl
      + '/updateEdiDunsMasterDetails', updatingedidunsmaster);
  }

  updateedimatlconv(updatingedimatlconv) {
    return this.httpClient.put<EdiMatlConv>(this.apiEdiMasterUrl
      + '/updateEdiMatlConvDetails', updatingedimatlconv);
  }
  updatestoreconvert(updatingstoreconvert) {
    return this.httpClient.put<StoreConvert>(this.apiEdiMasterUrl
      + '/updateStoreConvertDetails', updatingstoreconvert);
  }
  getPurchaseOrderReport(startDate, endDate) {
    return this.httpClient.get<PurchaseOrderReportDto[]>(this.apiUrl
      + '/getPurchaseOrderReport?startDate=' + startDate + '&endDate=' + endDate);
  }
  getBOLReport(startDate, endDate) {
    return this.httpClient.get<BOLReportDTO[]>(this.apiUrl
      + '/getBOLReport?startDate=' + startDate + '&endDate=' + endDate);
  }
  
  getPOLineItemDetailReport(startDate, endDate) {
    return this.httpClient.get<POLineItemDetailReportDTO[]>(this.apiUrl
      + '/getPOLineItemDetailReport?startDate=' + startDate + '&endDate=' + endDate);
  }
  getPartnersName() {
    return this.httpClient.get<PartnerDto[]>(this.apiMasterUrl + '/getPartnerListMSO');
  }
  getCustomersName() {
    return this.httpClient.get<PartnerDto[]>(this.apiMasterUrl + '/getCustomerListMSO');
  }

  deleteDunsId(dunsIdToBeDeleted) {
    return this.httpClient.delete<Enablesaveuseraccessdto>(this.apiEdiMasterUrl
      + '/deleteDunsId?dunsIdToBeDeleted=' + dunsIdToBeDeleted);
  }
  addDunsId(dunsIdObj) {
    return this.httpClient.post<Enablesaveuseraccessdto>(this.apiEdiMasterUrl + '/addDunsId', dunsIdObj);
  }

  updateOrderItems(updateOrderDto) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<OrderDetailsdto>(this.apiPurchaseOrderUrl + '/updatePurchaseOrderItem', updateOrderDto);
  }
  getCustomerLocationIds(customerModal) {
    return this.httpClient.get<CustomerLocationIds[]>(this.apiMasterUrl
      + '/getCustomerLocationIds?customerNumber=' + customerModal);
  }
  getDistributors(customerModal, customerLocationIdModel) {
    return this.httpClient.get<CustomerLocationIds[]>(this.apiMasterUrl
      + '/getDistributors?partnerNumber=' + customerModal + '&customerLocationId=' + customerLocationIdModel);
  }
  getMaterials(customerModal) {
    return this.httpClient.get<CustomerLocationIds[]>(this.apiMasterUrl
      + '/getMaterials?customerModal=' + customerModal);
  }
  createPO(poCreation) {
    return this.httpClient.post<Enablesaveuseraccessdto>(this.apiPoUrl + '/createPO', poCreation);
  }

  getBolLineItem(requestData) {
    return this.httpClient.post<BolItemLinesResponseDto[]>(this.apiBolUrl + '/getBolItemLines', requestData);
  }

  getOrderItemMasterList() {
    return this.httpClient.get<OrderItemMasterDto[]>(this.apiMasterUrl + '/getOrderItemMasterList');
  }

  getPoTypeMasterList() {
    return this.httpClient.get<PoTypeDto[]>(this.apiBolUrl + '/getPOTypes');
  }

  createBOL(requestData) {
    return this.httpClient.post<BolResponse>(this.apiBolUrl + '/createBol', requestData);
  }

  createBOLForReturnPo(requestData) {
    return this.httpClient.post<BolResponse>(this.apiBolUrl + '/createBolforReturnPO', requestData);
  }

  viewBOL(requestData) {
    return this.httpClient.post<BolResponse>(this.apiBolUrl + '/viewBolXML', requestData);
  }

  viewBOLForReturnPo(requestData) {
    return this.httpClient.post<BolResponse>(this.apiBolUrl + '/viewReturnBolXML', requestData);
  }
  getPOTypes() {
    return this.httpClient.get<PoTypesDto[]>(this.apiBolUrl + '/getPOTypes');
  }
  getExtensiveLoggingList() {
    return this.httpClient.get<ExtensiveLoggingDto[]>(this.apiMasterUrl + '/getExtensiveLoggingList');
  }

  updateExtensiveLogging(globelUserId, updatedExtensiveLog) {
    return this.httpClient.put<ExtensiveLoggingDto[]>(this.apiMasterUrl + '/updateExtensiveLog/' +
      globelUserId, updatedExtensiveLog);
  }

  getServiceStatusList(userId) {
    return this.httpClient.get<ServiceStatusDto[]>(this.apiServiceStatusUrl + '/getAllServices?userid=' + userId);
  }


  getPartnerOnboardingList() {
    return this.httpClient.get<PartnerOnboardingDto[]>(this.apiPartnerOnboardingUrl
      + '/getPartnerOnboardingList');
  }

  getSourceAndTargetList() {
    return this.httpClient.get<PartnerOnboardingMasterDto[]>(this.apiPartnerOnboardingUrl
      + '/getSourceAndTargetList');
  }

  getPartnerTypeList() {
    return this.httpClient.get<PartnerOnboardingMasterDto[]>(this.apiPartnerOnboardingUrl
      + '/getPartnerTypeList');
  }

  getOrderFlowTypeList() {
    return this.httpClient.get<PartnerOnboardingMasterDto[]>(this.apiPartnerOnboardingUrl
      + '/getOrderFlowTypeList');
  }

  getReferenceCodeTypeList() {
    return this.httpClient.get<PartnerOnboardingMasterDto[]>(this.apiPartnerOnboardingUrl
      + '/getReferenceCodeTypeList');
  }

  getPartnerOnboardingTransactionList(partnerId) {
    return this.httpClient.get<PartnerOnboardingTransactionDto[]>(this.apiPartnerOnboardingUrl
      + '/getPartnerOnboardingTransactionList/' + partnerId);
  }


  savePartnerStaging(partnerStagingDto) {
    return this.httpClient.post<PartneStagingDto>(this.apiPartnerOnboardingUrl
      + '/savePartnerStaging', partnerStagingDto);
  }


  savePartnerTransactionStaging(partnerId, loggedinId, partnerStagingDto) {
    return this.httpClient.put<PartneStagingDto>(this.apiPartnerOnboardingUrl
      + '/savePartnerTransaction/' + partnerId + '/' + loggedinId, partnerStagingDto);
  }


  checkPartnerNumber(partnerNumber, sapPayerNum) {
    return this.httpClient.get<boolean>(this.apiPartnerOnboardingUrl
      + '/checkPartnerNumber/' + partnerNumber + '/' +sapPayerNum);
  }


  enablePartner(partnerId, loggedinId) {
    return this.httpClient.get<boolean>(this.apiPartnerOnboardingUrl
      + '/enablePartner/' + partnerId + '/' + loggedinId);
  }
  getDateOnChangeExceReports(reportDateRanges) {
    return this.httpClient.post<MonthlyExceptionsReports[]>(this.apiUrl
      + '/getExceptionM2MandCCreport', reportDateRanges);
  }


  copyBolXML(requestData) {
    return this.httpClient.post<BolResponse>(this.apiBolUrl + '/copyBolXML', requestData);
  }

  getCustomerListMSO() {
    return this.httpClient.get<PartnerDto[]>(this.apiMasterUrl + '/getCustomerListMSO');
  }

  getPartnerNumberList() {
    return this.httpClient.get<PartnerOnboardingMasterDto[]>(this.apiPartnerOnboardingUrl
      + '/getPartnerNumberList');
  }


  getPartnerRefCodeList() {
    return this.httpClient.get<PartnerOnboardingMasterDto[]>(this.apiPartnerOnboardingUrl
      + '/getPartnerRefCode');
  }


  getPartnerOnboardingByPartnerId(partnerStatus, partnerId) {
    return this.httpClient.get<PartneStagingDto>(this.apiPartnerOnboardingUrl
      + '/getPartnerOnboardingListByPartnerId/' + partnerStatus + '/' + partnerId);
  }

  getPartnerOnboardingTransactionListStatus(partnerStatus, partnerId) {
    return this.httpClient.get<PartnerOnboardingTransactionDto[]>(this.apiPartnerOnboardingUrl
      + '/getPartnerOnboardingTransactionListStatus/' + partnerStatus + '/' + partnerId);
  }

  updatePartner(partnerStatus, partnerId, partnerStagingDto: PartneStagingDto) {
    return this.httpClient.put<any>(this.apiPartnerOnboardingUrl + '/updatePartner/' +
      partnerStatus + '/' + partnerId, partnerStagingDto);
  }


  updatePartnerTransactione(partnerStatus, partnerId, partnerStagingDto) {
    return this.httpClient.put<any>(this.apiPartnerOnboardingUrl + '/updatePartnerTransaction/' +
      partnerStatus + '/' + partnerId, partnerStagingDto);
  }
  getmsoLocationDateChange(partnerId) {
    return this.httpClient.get<MsoLocationReport[]>(this.apiUrl
      + '/getMsoLocationReport/' + partnerId);
  }

  getDistributorLocationDetails(partnerId,userId)
  {
    return this.httpClient.get<String>(this.apiUrl + '/getDistributorLocationDetails/' + partnerId + '/' + userId);
  }

  getBolDetailList(axaltacartkey,purchaseOrderNo,supplierDocRefNo)
  { 
    return this.httpClient.get<OrderDetailsdto>(this.apiBolUrl + '/bolDetail?axaltacartkey=' + axaltacartkey + '&purchaseOrderNo=' + purchaseOrderNo + '&supplierDocRefNo=' + supplierDocRefNo);
  }

  updateClearPurchaseOrderItem(updatingPO) {           
    return this.httpClient.get<String>(this.apiUrl + '/updateClearPurchaseOrderItem?axaltaCartKey=' + updatingPO);
  }

  updateClearZcraZdra(AxaltaCartKey, purchaseOrderNumber, documentTypeCodeId ) {
    return this.httpClient.get<String>(this.apiUrl + '/cancelZcraZdra/' +
    AxaltaCartKey + '/' + purchaseOrderNumber+ '/'+ documentTypeCodeId );
  }


}


